import { useNavigate } from 'react-router-dom';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { GameChatRoomData } from '~/types/missionGameApi';
import { GAEvent } from '~/utils';
import { GA, PAGE_ROUTE } from '~/constants';
import { stroke } from '~/styles/themes';
import { useUserStore } from '~/store';
import CharacterChip from './CharacterChip';

const GameChatRoomCard = ({
  chatRoomInfo,
  gameId,
  gameTitle,
}: {
  chatRoomInfo: GameChatRoomData;
  gameId: number;
  gameTitle: string;
}) => {
  const navigate = useNavigate();
  const email = useUserStore((state) => state.email);

  const handleGameRoomCardClick = () => {
    // send GA event : CLICK_GAMEROOM
    GAEvent(email, GA.ACTION.CLICK_GAMEROOM, {
      game_id: String(gameId),
      game_title: gameTitle,
      room_id: String(chatRoomInfo.game_chat_id),
      room_name: chatRoomInfo.name,
    });
    navigate(PAGE_ROUTE.MISSION_CHAT, {
      state: { chatRoomInfo: { ...chatRoomInfo, gameId } },
    });
  };
  return (
    <CardSliderContainer onClick={handleGameRoomCardClick}>
      <img
        width={245}
        height={435}
        src={chatRoomInfo.background_file_path}
        alt='chatroom background_file_path'
        style={{
          borderRadius: 18,
          border: `1px solid ${stroke.stroke_1}`,
          width: '100%',
          height: '100%',
        }}
      />
      <ChatRoomName>{chatRoomInfo.name}</ChatRoomName>
      <CharacterChip
        characters={chatRoomInfo.avatar_list}
        style={{ position: 'absolute', bottom: 8, right: 16 }}
      />
    </CardSliderContainer>
  );
};

export default GameChatRoomCard;

export const ChatRoomName = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.backgroundColor.bg_dark_4_alpha};
    color: ${theme.content.content_light_1};
    font-size: 16px;
  `}
  position: absolute;
  top: 50%;
  left: 50%;
  width: max-content;
  max-width: 200px;
  padding: 12px 16px;
  transform: translate(-50%, -50%);
  backdrop-filter: blur(4px);
  border-radius: 16px;
  font-weight: 500;
`;

const CardSliderContainer = styled.div`
  position: relative;
  width: 245px;
  height: 435px;
  border-radius: 16px;
`;
